import { render } from "./residents.vue?vue&type=template&id=339023df&scoped=true&ts=true"
import script from "./residents.vue?vue&type=script&lang=ts"
export * from "./residents.vue?vue&type=script&lang=ts"

import "./residents.vue?vue&type=style&index=0&id=339023df&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339023df"]])

export default __exports__